import {checkIfMerchandisedUrl} from "@next/utils"
import {SearchApiRequestTypes} from "../../../config/constants"
import {urlSanitiser} from "../../httpUrlTrimmer"
import {getAreaSegment} from "../../getAreaSegment"

export interface CategoryUrlSegments {
    category: string
    filter: string
    page: string
    department?: string
}

export const getCategorySearchMerchanisedUrlSegment = (
    url: string,
    type: SearchApiRequestTypes,
): CategoryUrlSegments => {
    if (type !== SearchApiRequestTypes.Category) {
        return {category: "", filter: "", page: ""}
    }
    const sanitisedPath = urlSanitiser(url)
    const areaSegment = getAreaSegment(sanitisedPath)
    const splitPathArraySegments = url.split("/")
    if (splitPathArraySegments.length <= 2) {
        return {category: "", filter: "", page: "", department: ""}
    }

    const splitPathArray = sanitisedPath.split("/f/")
    const splitForNoFiltersOnPath = splitPathArray[1] ? splitPathArray[1] : splitPathArray[0]
    let category = splitPathArray[0].split("/").slice(2).join("/")

    const filter = splitPathArray[1]?.split("?")[0] || ""
    category = category.includes("?") ? category.split("?")[0] : category
    if (category.endsWith("/")) {
        category = category.substring(0, category.length - 1)
    }
    const pageSplit = splitForNoFiltersOnPath.includes("?") ? splitForNoFiltersOnPath.split("?")[1] : undefined
    const page = pageSplit !== undefined ? `?${pageSplit}` : ""

    let department = ""
    const segments = category.split("/")
    switch (areaSegment) {
        case "shop":
            // eslint-disable-next-line prefer-destructuring
            department = segments[0]
            break
        case "brands":
        case "promotions":
            // eslint-disable-next-line prefer-destructuring
            department = segments[1]
            break

        default:
            department = ""
    }

    return {category, filter, page, department}
}

// have this return an object of the different segments
// URL url without siteurl , e.g. /shop/gender-women/colour-red
export const getCategorySearchUrlSegment = (url: string, type: SearchApiRequestTypes): CategoryUrlSegments => {
    if (type !== SearchApiRequestTypes.Category) {
        return {category: "", filter: "", page: ""}
    }

    const sanitisedPath = urlSanitiser(url)
    if (checkIfMerchandisedUrl(sanitisedPath)) {
        return getCategorySearchMerchanisedUrlSegment(url, type)
    }
    const splitPathArray = sanitisedPath.split("/")
    const splitForNoFiltersOnPath = splitPathArray[2].split("?")
    const category = splitForNoFiltersOnPath[0]
    let page = splitForNoFiltersOnPath[1] ? `?${splitForNoFiltersOnPath[1]}` : ""

    // TO DO - get page out
    const filter = splitPathArray[3]?.split("?")[0] || ""
    const pageSplit = splitPathArray[3]?.split("?")[1]
    page = pageSplit !== undefined ? `?${pageSplit}` : page
    return {category, filter, page}
}
